import { Injectable } from "@angular/core";
import { IAppsOverviewStateService } from "./i-apps-overview-state-service";
import { AOverviewStateService } from "@zaeper/angular-dashboard-view-lib";
import { IApp } from "@zaeper/angular-application-store-lib";

@Injectable()
export class AppsOverviewStateService extends AOverviewStateService<IApp> implements IAppsOverviewStateService {

}
